module.exports = __webpack_public_path__ + "static/img/tr.e555ceea.png";